import { useState } from "react";
import { useTranslation } from "@web-monorepo/i18next";
import ToolkitAppScroller from "components/BeyondToolkit/ToolkitAppScroller";
import ToolkitGridItem from "components/ToolkitGridItem";
import ToolkitVideoPlayer from "components/ToolkitVideoPlayer";
import { episodes, ReadAlongEpisode } from "data/readAlongEpisodes";
import { closeWebview } from "src/pods/webviewInit";
import { logParentToolkitEvent } from "src/utils/logEvent";
import { READ_ALONGS } from "utils/beyondToolkitTools";
import { sendUsage, fetchQuota } from "utils/freemium";

function ReadAlongs() {
  // this tells i18next to load these namespaces
  const { ready } = useTranslation(["dojo.beyond"]);

  const [episodeSelected, setEpisodeSelected] = useState<ReadAlongEpisode | null>(null);
  const [quotaReached, setQuotaReached] = useState(false);

  const { title, background, imgSrc } = READ_ALONGS();

  if (!ready) return null;

  return (
    <div>
      {episodeSelected == null ? (
        <ToolkitAppScroller title={title} color={background} imgSrc={imgSrc}>
          <div sx={{ display: "grid", gridGap: "dt_s", margin: "dt_s", gridTemplateColumns: "1fr 1fr" }}>
            {episodes.map((episode, i) => {
              return (
                <ToolkitGridItem
                  key={i}
                  index={i}
                  title={episode.title}
                  subTitle={`${episode.seriesTitle} • ${episode.duration} min`}
                  imgSrc={episode.imgSrc}
                  imgBackgroundSize={"200%"}
                  noBorder
                  onItemClick={() => {
                    logParentToolkitEvent({ eventName: `read_alongs.${episode.loggingId}.tap` });
                    setEpisodeSelected(episode);
                  }}
                />
              );
            })}
          </div>
        </ToolkitAppScroller>
      ) : (
        <ToolkitVideoPlayer
          videoSrc={episodeSelected.videoSrc}
          onClose={() => {
            setEpisodeSelected(null);
            if (quotaReached) {
              closeWebview();
            }
          }}
          sendUsage={async () => {
            await sendUsage("readAlongs");
            const quota = await fetchQuota();

            if (!quota.readAlongs.available) {
              setQuotaReached(true);
            }
          }}
        />
      )}
    </div>
  );
}

export default ReadAlongs;
